// removed by extract-text-webpack-plugin
module.exports = {"mobile-screen":"mobile-screen","mobile-wrapper":"mobile-wrapper","mobile-logo":"mobile-logo","mobile-content":"mobile-content","mobile-text-title":"mobile-text-title","mobile-btn":"mobile-btn","btn-primary":"btn-primary"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Main/MobileScreen.scss
// module id = ifxQ
// module chunks = 0